// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"LeaveConfirmationModal_buttonsContainer__7gbEe"};